// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__3YLjw","question":"Question_question__3qyVP","description":"Question_description__3azke"};